"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.iconStyles = void 0;

var _styledComponents = require("styled-components");

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var iconStyles = (0, _styledComponents.css)(["margin:2px ", " 0 0;"], _tokens["default"].spaceSm);
exports.iconStyles = iconStyles;
var errorMessageStyles = (0, _styledComponents.css)(["", " color:", ";margin:", " 0 0 0;"], _stylers["default"].lineHeight(-1), _tokens["default"].color.orangeDarken10, _tokens["default"].spaceSm);
var _default = errorMessageStyles;
exports["default"] = _default;
//# sourceMappingURL=ErrorMessage.styles.js.map